import { Record } from 'immutable';

export type CategoryTileType = {
  key?: string;
  name?: string;
  image?: string;
  backgroundColor?: string;
  resolveHref?: string;
  hoverBackgroundColor?: string;
};

export default Record<CategoryTileType>({
  key: undefined,
  name: undefined,
  image: undefined,
  backgroundColor: undefined,
  resolveHref: undefined,
  hoverBackgroundColor: undefined,
});
